export enum SyncStateType {
  None = 0,
  INSERT = 1,
  UPDATE = 2,
  DELETE = 3,
  SOFTDELETE = 4,
}
